Turbo.StreamActions.remove_attribute ||= function() {
  const attribute = this.getAttribute('attribute')
  this.targetElements.forEach(target => target.removeAttribute(attribute))
}

Turbo.StreamActions.close_modal ||= function() {
  const el = document.querySelector('[data-controller~="turbo-modal"]')
  if (el) {
    // Web: close the turbo-modal dialog via Stimulus controller
    window.Stimulus.getControllerForElementAndIdentifier(el, 'turbo-modal')?.close()
  } else {
    // iOS/Android native: sentinel URL — jamais chargée côté serveur.
    // Le NavigatorDelegate natif intercepte /close_native_modal, dismiss la modal
    // et rejette la navigation (.reject) avant tout round-trip réseau.
    Turbo.visit('/close_native_modal')
  }
}
